import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
const benefits = [
    { num: "01", text: "Last longer in bed with genuine control over your arousal" },
    { num: "02", text: "Get harder and stay harder, naturally and reliably" },
    { num: "03", text: "Stay present and fully engaged with your partner" },
    { num: "04", text: "Build a deeper connection with your own body" },
    { num: "05", text: "Grow your confidence and ease in intimate situations" },
    { num: "06", text: "Reignite passion and bring your love life to a new level" },
    { num: "07", text: "A non-addictive, drug-free practice you can sustain for life" },
];
const BenefitsSection = () => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
        } }, { threshold: 0.1 });
        if (ref.current)
            observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return (_jsx("section", { id: "benefits", className: "py-24 md:py-32", children: _jsxs("div", { className: "container mx-auto px-6", ref: ref, children: [_jsxs("div", { className: "text-center mb-16", style: {
                        opacity: visible ? 1 : 0,
                        transform: visible ? "translateY(0)" : "translateY(20px)",
                        transition: "opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1)",
                    }, children: [_jsx("p", { className: "uppercase tracking-[0.25em] text-sm font-semibold mb-5 text-brand-gradient", children: "What You'll Gain" }), _jsxs("h2", { className: "font-sans font-black text-foreground text-4xl md:text-5xl", children: ["The benefits of a", _jsx("br", {}), "regular Rino practice"] })] }), _jsx("div", { className: "max-w-3xl mx-auto divide-y divide-border", children: benefits.map((b, i) => (_jsxs("div", { className: "flex items-center gap-8 py-7 group", style: {
                            opacity: visible ? 1 : 0,
                            transform: visible ? "translateX(0)" : "translateX(-16px)",
                            transition: `opacity 0.6s cubic-bezier(0.16,1,0.3,1) ${i * 0.07}s, transform 0.6s cubic-bezier(0.16,1,0.3,1) ${i * 0.07}s`,
                        }, children: [_jsx("span", { className: "text-brand-gradient font-black text-2xl tabular-nums w-12 shrink-0", children: b.num }), _jsx("p", { className: "text-foreground/75 text-lg group-hover:text-foreground transition-colors duration-200 leading-snug", children: b.text })] }, b.num))) })] }) }));
};
export default BenefitsSection;
